var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PlacementMultiplier',{attrs:{"promotionFactor":_vm.promotionFactorComputed,"currencyName":_vm.currencyNameComputed,"reward":_vm.rewardComputed},on:{"changeMultiplierFactor":_vm.changeMultiplierFactor}})}
var staticRenderFns = []

export { render, staticRenderFns }